'use strict';

angular.module('shiftTraderApp')
  .controller('ModalPublishingCtrl', function($scope, params, $uibModalInstance, GlobalRxFeed) {
    $scope.org = params.org;
    $scope.currentDate = params.currentDate;
    $scope.workPeriodsByPositionId = params.workPeriodsByPositionId;

    $uibModalInstance.rendered.then(function () {
      GlobalRxFeed.push('modal-opened', 'publish-schedule', $uibModalInstance)
    })

    $scope.close = function() {
      $uibModalInstance.dismiss();
    };

    $scope.allDepartments = _.map(_.cloneDeep($scope.org.departments), function(dept) {
      var numWorkPeriodsToBePublishedInDepartment = 0;
      dept._selected = false;
      dept.positions = _.map(_.where(dept.positions, {active: true}), function(pos) {
        pos._numWorkPeriodsToBePublished = $scope.workPeriodsByPositionId[pos.id];
        numWorkPeriodsToBePublishedInDepartment += pos._numWorkPeriodsToBePublished;
        return pos;
      });
      dept._numWorkPeriodsToBePublished = numWorkPeriodsToBePublishedInDepartment;
      return dept;
    });

    $scope.selectAllPositionsInDept = function(dept) {
      _.each(dept.positions, function(pos) {
        if (pos._numWorkPeriodsToBePublished > 0) {
          pos._selected = true;
        }
      });

      dept._anySelected = true;
      dept._allSelected = true;
    };

    $scope.deselectAllPositionsInDept = function(dept) {
      _.each(dept.positions, function(pos) {
        pos._selected = false;
      });

      dept._anySelected = false;
      dept._allSelected = false;
    };

    $scope.togglePositionSelection = function(pos) {
      pos._selected = !pos._selected;

      var idx = _.findIndex($scope.allDepartments, {id: pos.department_id});
      $scope.allDepartments[idx]._anySelected = _.any($scope.allDepartments[idx].positions, function(pos) {
        return pos._selected && pos._numWorkPeriodsToBePublished > 0;
      });

      $scope.allDepartments[idx]._allSelected = _.all($scope.allDepartments[idx].positions, function(pos) {
        return pos._selected || pos._numWorkPeriodsToBePublished === 0;
      });
    };

    $scope.closeAndPublish = function() {
      var positionIds = [];
      _.each($scope.allDepartments, function(dept) {
        _.each(dept.positions, function(pos) {
          if (pos._selected) {
            positionIds.push(pos.id);
          }
        });
      });

      $uibModalInstance.close(positionIds);
    };

    $scope.countSelectedWorkPeriods = function(dept) {
      return _.reduce(_.map(dept.positions, function(pos) {
        if (pos._selected) {
          return pos._numWorkPeriodsToBePublished;
        } else {
          return 0;
        }
      }), function(x,y) {
        return x + y;
      });
    };

    $scope.isSomethingSelected = function() {
      return _.any(_.map($scope.allDepartments, function(dept) {
        return _.any(dept.positions, function(pos) {
          return pos._selected;
        });
      }));
    };

  });
